import React from "react";
import usePageContent from "../../hooks/usePageContent";
import EditableSection from "../../components/CMS/EditableSection";
import "../AllPage.css";
import "./CompetitionsPage.css";


/* =========================================================
   COMPETITIONS PAGE
========================================================= */

const CompetitionsPage = ({ user }) => {

    const {
        sections,
        get,
        loading,
        error,
        refresh
    } = usePageContent("competitions");

    const editable = user?.role === "admin";

    const header = get("header");
    const competitions = get("competitions");
    const hostCta = get("host-cta");


    if (loading && sections.length === 0) {
        return <div>Loading Competitions...</div>;
    }

    if (error && sections.length === 0) {
        return <div>Error: {error}</div>;
    }


    const getSection = key =>
        sections.find(
            s => s.section_key === key
        );


    const headerSection =
        getSection("header");

    const competitionsSection =
        getSection("competitions");

    const hostCtaSection =
        getSection("host-cta");


    return (
        <div className="competitions-page">


            {/* =================================================
                HEADER
            ================================================= */}

            {/* {headerSection && (
                <EditableSection
                    uniqueId={headerSection.unique_id}
                    title={headerSection.title}
                    data={header}
                    editable={editable}
                    Editor={CompetitionHeaderEditor}
                    onSaved={refresh}

                    Display={({ data }) => (

                        <section
                            id="competition"
                            className="competition-section"
                        >

                            <div className="container">

                                <div className="competition-title">

                                    <h3 className="section_title">
                                        {data?.title}
                                    </h3>

                                    {data?.description && (
                                        <p>
                                            {data.description}
                                        </p>
                                    )}

                                </div>

                            </div>

                        </section>

                    )}
                />
            )} */}



            {/* =================================================
                COMPETITIONS
            ================================================= */}

            {competitionsSection && (
                <EditableSection
                    uniqueId={competitionsSection.unique_id}
                    title={competitionsSection.title}
                    data={competitions}
                    editable={editable}
                    Editor={CompetitionListEditor}
                    onSaved={refresh}

                    Display={({ data }) => (

                        <section
                            id="competition-list"
                            className="competition-section"
                        >

                            <div className="container">


                                {/* =================================
                                    CURRENT COMPETITIONS
                                ================================= */}

                                {data?.current?.items?.length > 0 && (

                                    <div className="competition-group">

                                        <h2 className="competition-group-title">
                                            {data.current.title ||
                                                "Current Competitions"}
                                        </h2>


                                        <CompetitionCards
                                            items={
                                                data.current.items
                                            }
                                        />

                                    </div>

                                )}



                                {/* =================================
                                    PAST COMPETITIONS
                                ================================= */}

                                {data?.past?.items?.length > 0 && (

                                    <div className="competition-group past-competitions">

                                        <h2 className="competition-group-title">
                                            {data.past.title ||
                                                "Past Competitions"}
                                        </h2>


                                        <CompetitionCards
                                            items={
                                                data.past.items
                                            }
                                        />

                                    </div>

                                )}


                            </div>

                        </section>

                    )}
                />
            )}



            {/* =================================================
                HOST CTA
            ================================================= */}

            {hostCtaSection && (
                <EditableSection
                    uniqueId={hostCtaSection.unique_id}
                    title={hostCtaSection.title}
                    data={hostCta}
                    editable={editable}
                    Editor={HostCompetitionEditor}
                    onSaved={refresh}

                    Display={({ data }) => (

                        <section className="competition-host-cta">

                            <div className="container">

                                <a
                                    href={
                                        data?.url || "#"
                                    }
                                    className={
                                        data?.className ||
                                        "btn btn-success"
                                    }
                                >
                                    {data?.text ||
                                        "Interested in Hosting a Competition"}
                                </a>

                            </div>

                        </section>

                    )}
                />
            )}

        </div>
    );
};



/* =========================================================
   COMPETITION CARDS
========================================================= */

const CompetitionCards = ({ items = [] }) => {

    return (

        <div className="row g-4">

            {items.map((item, index) => (

                <div
                    className="col-lg-4 col-md-6"
                    key={index}
                >

                    <div className="competition-card">


                        {/* =================================
                            BADGE
                        ================================= */}

                        <div className="competition-header">

                            {item.badge && (

                                <span
                                    className={
                                        `competition-badge ${
                                            item.badgeClass || ""
                                        }`
                                    }
                                >
                                    {item.badge}
                                </span>

                            )}

                        </div>



                        {/* =================================
                            TITLE
                        ================================= */}

                        {item.title && (
                            <h3>
                                {item.title}
                            </h3>
                        )}



                        {/* =================================
                            SUBTITLE
                        ================================= */}

                        {item.subtitle && (
                            <h5>
                                {item.subtitle}
                            </h5>
                        )}



                        {/* =================================
                            IMAGE
                        ================================= */}

                        {item.image && (

                            <img
                                src={item.image}
                                className="competition-image"
                                alt={
                                    item.alt ||
                                    item.title ||
                                    "Competition"
                                }
                            />

                        )}



                        {/* =================================
                            BUTTON
                        ================================= */}

                        {item.url && (

                            <div className="competition-button">

                                <a
                                    href={item.url}
                                    className="btn btn-outline-info"
                                >
                                    {item.buttonText ||
                                        "Learn More"}
                                </a>

                            </div>

                        )}

                    </div>

                </div>

            ))}

        </div>

    );
};



/* =========================================================
   HEADER EDITOR
========================================================= */

const CompetitionHeaderEditor = ({
    data,
    update
}) => (

    <div className="cms-editor">


        <label>
            Title
        </label>

        <input
            value={data?.title || ""}
            onChange={e =>
                update(
                    "title",
                    e.target.value
                )
            }
        />


        <label>
            Description
        </label>

        <textarea
            value={
                data?.description || ""
            }
            onChange={e =>
                update(
                    "description",
                    e.target.value
                )
            }
        />

    </div>

);



/* =========================================================
   COMPETITION LIST EDITOR
========================================================= */

const CompetitionListEditor = ({
    data,
    update
}) => {

    const current =
        data?.current || {
            title: "Current Competitions",
            items: []
        };

    const past =
        data?.past || {
            title: "Past Competitions",
            items: []
        };


    /* =====================================================
       UPDATE GROUP
    ===================================================== */

    const updateGroup = (
        group,
        field,
        value
    ) => {

        update(
            group,
            {
                ...data?.[group],
                [field]: value
            }
        );

    };


    /* =====================================================
       UPDATE ITEM
    ===================================================== */

    const updateCompetition = (
        group,
        index,
        field,
        value
    ) => {

        const items = [
            ...(data?.[group]?.items || [])
        ];

        items[index] = {
            ...items[index],
            [field]: value
        };

        updateGroup(
            group,
            "items",
            items
        );

    };


    /* =====================================================
       ADD ITEM
    ===================================================== */

    const addCompetition = group => {

        const items = [
            ...(data?.[group]?.items || [])
        ];


        items.push({
            title: "",
            subtitle: "",
            badge: "",
            badgeClass:
                group === "current"
                    ? "success"
                    : "secondary",
            image: "",
            alt: "",
            buttonText:
                group === "current"
                    ? "Learn More"
                    : "View Results",
            url: ""
        });


        updateGroup(
            group,
            "items",
            items
        );

    };


    /* =====================================================
       DELETE ITEM
    ===================================================== */

    const removeCompetition = (
        group,
        index
    ) => {

        const items = [
            ...(data?.[group]?.items || [])
        ];

        items.splice(index, 1);

        updateGroup(
            group,
            "items",
            items
        );

    };


    /* =====================================================
       RENDER ITEM EDITOR
    ===================================================== */

    const renderCompetitionEditor = (
        group,
        items
    ) => (

        <>

            {(items || []).map(
                (item, index) => (

                    <div
                        className="cms-item"
                        key={index}
                    >


                        {/* =========================
                            ITEM HEADER
                        ========================= */}

                        <div className="cms-item-header">

                            <strong>
                                Competition{" "}
                                {index + 1}
                            </strong>

                            <button
                                type="button"
                                className="cms-delete"
                                onClick={() =>
                                    removeCompetition(
                                        group,
                                        index
                                    )
                                }
                            >
                                Delete
                            </button>

                        </div>



                        {/* =========================
                            TITLE
                        ========================= */}

                        <label>
                            Title
                        </label>

                        <input
                            value={
                                item.title || ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "title",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            SUBTITLE
                        ========================= */}

                        <label>
                            Subtitle
                        </label>

                        <input
                            value={
                                item.subtitle || ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "subtitle",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            BADGE
                        ========================= */}

                        <label>
                            Badge
                        </label>

                        <input
                            value={
                                item.badge || ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "badge",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            BADGE CSS
                        ========================= */}

                        <label>
                            Badge CSS Class
                        </label>

                        <input
                            value={
                                item.badgeClass ||
                                ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "badgeClass",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            IMAGE
                        ========================= */}

                        <label>
                            Image
                        </label>

                        <input
                            value={
                                item.image || ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "image",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            ALT TEXT
                        ========================= */}

                        <label>
                            Image Alt Text
                        </label>

                        <input
                            value={
                                item.alt || ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "alt",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            BUTTON TEXT
                        ========================= */}

                        <label>
                            Button Text
                        </label>

                        <input
                            value={
                                item.buttonText ||
                                ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "buttonText",
                                    e.target.value
                                )
                            }
                        />



                        {/* =========================
                            BUTTON URL
                        ========================= */}

                        <label>
                            Button URL
                        </label>

                        <input
                            value={
                                item.url || ""
                            }
                            onChange={e =>
                                updateCompetition(
                                    group,
                                    index,
                                    "url",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                )
            )}



            {/* =========================
                ADD BUTTON
            ========================= */}

            <button
                type="button"
                className="cms-add"
                onClick={() =>
                    addCompetition(group)
                }
            >
                + Add Competition
            </button>

        </>

    );


    return (

        <div className="cms-editor">


            {/* =================================================
                CURRENT COMPETITIONS
            ================================================= */}

            <div className="cms-group">

                <h3>
                    Current Competitions
                </h3>


                <label>
                    Section Title
                </label>

                <input
                    value={
                        current.title || ""
                    }
                    onChange={e =>
                        updateGroup(
                            "current",
                            "title",
                            e.target.value
                        )
                    }
                />


                {renderCompetitionEditor(
                    "current",
                    current.items
                )}

            </div>



            {/* =================================================
                PAST COMPETITIONS
            ================================================= */}

            <div
                className="cms-group"
                style={{
                    marginTop: "40px"
                }}
            >

                <h3>
                    Past Competitions
                </h3>


                <label>
                    Section Title
                </label>

                <input
                    value={
                        past.title || ""
                    }
                    onChange={e =>
                        updateGroup(
                            "past",
                            "title",
                            e.target.value
                        )
                    }
                />


                {renderCompetitionEditor(
                    "past",
                    past.items
                )}

            </div>

        </div>

    );
};



/* =========================================================
   HOST COMPETITION CTA EDITOR
========================================================= */

const HostCompetitionEditor = ({
    data,
    update
}) => (

    <div className="cms-editor">


        <label>
            Button Text
        </label>

        <input
            value={
                data?.text || ""
            }
            onChange={e =>
                update(
                    "text",
                    e.target.value
                )
            }
        />


        <label>
            URL
        </label>

        <input
            value={
                data?.url || ""
            }
            onChange={e =>
                update(
                    "url",
                    e.target.value
                )
            }
        />


        <label>
            CSS Class
        </label>

        <input
            value={
                data?.className || ""
            }
            onChange={e =>
                update(
                    "className",
                    e.target.value
                )
            }
        />

    </div>

);


export default CompetitionsPage;